export const NAMESPACE = 'archives-page';
